import { firebaseClient } from "firebaseClient";
import moment from "moment";

const sortDateNum = (numA = NaN, numB = NaN) => {
    const sortVal = (!Number.isNaN(numA) && !Number.isNaN(numB)) ? numA - numB : 0;

    return (sortVal > 0) ? 1 : (sortVal == 0) ? 0 : -1;
}

const sortStringPart = (dateStringA = undefined, dateStringB = undefined) => {
    if (dateStringA == undefined || dateStringB == undefined) return 0;

    const stringDateOrder = ['now', 'ms', 's', 'm', 'h', 'd', 'w', 'mo', 'yr'];
    const indexStrinDateA = stringDateOrder.indexOf(dateStringA);
    const indexStrinDateB = stringDateOrder.indexOf(dateStringB);

    const sortVal = (indexStrinDateA != undefined && indexStrinDateB != undefined)
        ? indexStrinDateA - indexStrinDateB
        : 0;

    return (sortVal > 0) ?
        1
        : (sortVal == 0) ? 0 : -1;
}

const getSortValue = (checkString: string = "") => {
    if (!checkString) return false;
    return [...checkString.matchAll(/^(\d+)(\w+)|now/gi)];
}

export const customDateSort = (rowA, rowB, id, desc) => {
    const sortValueA = moment(rowA.values['date'], "MMM. Do ’YY @ HH:mm").toDate().getTime();
    const sortValueB = moment(rowB.values['date'], "MMM. Do ’YY @ HH:mm").toDate().getTime();
    const sortedNumberValue = sortDateNum(sortValueB, sortValueA);
    return sortedNumberValue;
};

export const customEngagementPercentSort = (rowA, rowB, id, desc) => {
    const sortedNumberValue = rowA.values['engagementPercent'] - rowB.values['engagementPercent'];
    return (sortedNumberValue > 0) ? 1 : (sortedNumberValue == 0) ? 0 : -1;
};

//remove in lieu of numbro which is already installed.
export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const createSeries = (timeframe: any = undefined) => {
    if (!timeframe) return [];
    const series: any = []; //can't use let, because it be a referenced copy when copied.
    let start, end;
    if (timeframe?.start) {
        start = moment(timeframe.start);
        end = moment(timeframe.end);
    } else {
        start = moment(timeframe);
        end = moment().subtract(1, "day");
    }

    const differenceInDays = end.diff(start, "days");
    for (let i = 0, currentDate = moment(start); i <= differenceInDays; i++) {
        series.push({ date: currentDate?.format("MMM. Do ’YY") });
        currentDate.add(1, "day");
    }

    return series;
}

export const fillUnfilledSeries = (
    currentCorrectValue = 0,
    currentIndex = 0,
    seriesArray: any = [],
    keyToCheck = 'objectKey',
    padWithZero = false
) => {

    if (currentIndex < 0 || seriesArray == undefined || seriesArray?.length <= 0 || keyToCheck == "objectKey") return;

    const prevIndex = (currentIndex - 1 < 0) ? 0 : currentIndex - 1;
    const nextIndex = ((currentIndex + 1) >= (seriesArray.length)) ? seriesArray.length - 1 : currentIndex + 1;

    if (prevIndex == 0 && nextIndex == 0 && currentIndex == 0) {
        seriesArray[currentIndex][keyToCheck] = currentCorrectValue;
        return;
    }

    if (seriesArray[prevIndex] &&
        (keyToCheck in seriesArray[prevIndex]) &&
        seriesArray[currentIndex] &&
        (keyToCheck in seriesArray[currentIndex])) {
        return;
    }

    if (nextIndex == currentIndex &&
        seriesArray[currentIndex] &&
        !(keyToCheck in seriesArray[currentIndex])) {
        fillUnfilledSeries(currentCorrectValue, prevIndex, seriesArray, keyToCheck);
    }

    if (seriesArray[prevIndex] && !(keyToCheck in seriesArray[prevIndex])) {
        if (currentIndex == 0 && prevIndex == 0) {
            seriesArray[prevIndex][keyToCheck] = currentCorrectValue;
            return;
        }
        fillUnfilledSeries(currentCorrectValue, prevIndex, seriesArray, keyToCheck);
    }

    if (seriesArray[prevIndex] &&
        (keyToCheck in seriesArray[prevIndex]) &&
        seriesArray[currentIndex] &&
        !(keyToCheck in seriesArray[currentIndex])) {
        seriesArray[currentIndex][keyToCheck] = seriesArray[prevIndex]?.[keyToCheck];
        currentCorrectValue = seriesArray[prevIndex]?.[keyToCheck];
        fillUnfilledSeries(currentCorrectValue, nextIndex, seriesArray, keyToCheck);
    }

    return;
}

// export const calculatePercentageValue = (numA, numB) => {
//     const numChange = numA - numB || 0;
//     return (numA != 0)
//             ? Number(numChange / numA * 100).toFixed(2) || 0
//             : ( (numA !=0 ) ? 100 : 0);
// }

export const calculatePercentageValue = (numA, numB) => {
    const numChange = (numA / numB) || 0;
    return (numA != 0 && numChange != Infinity)
        ? Number((numChange - 1) * 100).toFixed(2) || 0
        : ((numA != 0) ? 100 : 0);
}

export const getExactPostDate = (postId = "") => {
    if (!postId) return;

    const convertToBinary = BigInt(postId).toString(2);
    const first41Chars = convertToBinary.slice(0, 41);
    const timestamp = parseInt(first41Chars, 2);
    const dateObj = new Date(timestamp);
    return dateObj;
}

export const getPostsForDates = (tweetStats: any = [], mode = "personal", dataPoint = { date: undefined }) => {
    if (!tweetStats || !dataPoint?.date) return [];

    const postForDates = tweetStats.filter((
        (n, i, arr) => {
            const toCheckDateAgainst = getDateToCheckAgainst(n, mode);
            return toCheckDateAgainst === dataPoint?.date;
        }
    ));

    return postForDates;
}

export const getDateToCheckAgainst = (post, mode) => {
    const idDate = getExactPostDate(post?.idShort);
    return (idDate)
        ? moment(idDate)?.format("MMM. Do ’YY")
        : (mode == "personal") && post?.created_at?.toDate
            ?
            moment.utc(post?.created_at.toDate
                ? post?.created_at.toDate()
                : new Date(post?.created_at._seconds * 1000))?.format("MMM. Do ’YY")
            :
            moment.utc(new Date().setTime(post?.dateAdded?._seconds * 1000))?.format("MMM. Do ’YY")
        ;
    ;
};

export const findLastFoundValueCountIndex = (arr, objectKey) => {
    if (!arr || !arr?.length || !objectKey) return;
    const lastIndex = arr.findLastIndex((el) => {
        if (el?.[objectKey]) return true;
        else return false;
    });
    return lastIndex;
}

export const readyOrgStats = async (memberAccountStats, timeFrame) => {
    if (memberAccountStats.length == 0 || !timeFrame) return;

    let accountStats = createSeries(timeFrame);

    memberAccountStats.forEach((mem, i) => {
        let accountDayStat = createSeries(timeFrame);

        accountDayStat.forEach((day, i, daySeries) => {
            const index = mem.findIndex((stat, j) => {
                return moment.utc(new Date().setTime(stat?.dateFetched?._seconds * 1000))?.format("MMM. Do ’YY") === day?.date;
            });

            let correctFollowerCount = 0;
            let correctViewCount = 0;
            let correctConnectionCount = 0;

            if (index != -1) {
                if (!accountDayStat[i]?.followerCount) accountDayStat[i].followerCount = 0;
                if (!accountDayStat[i]?.connectionCount) accountDayStat[i].connectionCount = 0;
                if (!accountDayStat[i]?.connectionCount) accountDayStat[i].viewCounts = 0;

                const calcFollowerCount =
                    (
                        mem[index]?.followerCount == undefined
                        || Number.isNaN(mem[index]?.followerCount)
                        || mem[index]?.followerCount == Infinity
                    )
                        ? mem[findLastFoundValueCountIndex(mem, 'followerCount')]?.followerCount
                        : mem[index]?.followerCount
                    ;

                const calcConnectionCount =
                    (
                        mem[index]?.connectionCount == undefined
                        || Number.isNaN(mem[index]?.connectionCount)
                        || mem[index]?.connectionCount == Infinity
                    )
                        ? mem[findLastFoundValueCountIndex(mem, 'connectionCount')]?.connectionCount
                        : mem[index]?.connectionCount
                    ;

                const calcViewCounts =
                    (
                        mem[index]?.viewCounts == undefined
                        || Number.isNaN(mem[index]?.viewCounts)
                        || mem[index]?.viewCounts == Infinity
                    )
                        ? mem[findLastFoundValueCountIndex(mem, 'viewCounts')]?.viewCounts
                        : mem[index]?.viewCounts
                    ;

                accountDayStat[i].followerCount = correctFollowerCount = calcFollowerCount ?? 0;
                accountDayStat[i].connectionCount = correctConnectionCount = calcConnectionCount ?? 0;
                accountDayStat[i].viewCounts = calcViewCounts ?? 0;

                fillUnfilledSeries(correctFollowerCount, i, accountDayStat, "followerCount");
                fillUnfilledSeries(correctConnectionCount, i, accountDayStat, "connectionCount");
                fillUnfilledSeries(correctViewCount, i, accountDayStat, "viewCounts");

            } else if (i == daySeries.length - 1) {
                fillUnfilledSeries(correctFollowerCount, i, accountDayStat, "followerCount");
                fillUnfilledSeries(correctConnectionCount, i, accountDayStat, "connectionCount");
                fillUnfilledSeries(correctViewCount, i, accountDayStat, "viewCounts");
            }

            // console.group('org states --');
            // console.log(accountDayStat);
            // console.groupEnd();
        });

        accountStats = accountStats.map((sumStats, i) => {
            const index = accountDayStat.findIndex((day) => {
                return day?.date === sumStats?.date;
            });

            if (index != -1) {
                if (!sumStats?.followerCount) sumStats.followerCount = 0;
                if (!sumStats?.connectionCount) sumStats.connectionCount = 0;
                if (!sumStats?.connectionCount) sumStats.viewCounts = 0;

                sumStats.followerCount += accountDayStat[index]?.followerCount ?? 0;
                sumStats.connectionCount += accountDayStat[index]?.connectionCount ?? 0;
                sumStats.viewCounts += accountDayStat[index]?.viewCounts ?? 0;

                sumStats.dateFetched = {
                    _seconds: moment.utc(sumStats?.date, "MMM. Do ’YY").unix(),
                    _nanoseconds: moment.utc(sumStats?.date, "MMM. Do ’YY").valueOf() * 1000000
                };
            }
            return sumStats;
        });

    });
    return accountStats;
}

export const yDomain =
    (data) => {
        const y = data.map((s) => {
            return s?.y || 0;
        });

        const yD = [
            ((Math.min(...y) * 0.95)),
            ((Math.max(...y) * 1.05))
        ]

        return yD;
    }

export const countProfileViews = (accountStats: any = []) => {
    const totalProfileViews = accountStats.reduce(
        (profileViewsCount, dayStats, index) => {
            const currentViews = (dayStats?.viewCounts?.viewCounts) ? dayStats?.viewCounts.views : dayStats?.viewCounts || 0;

            const yesterViews = (accountStats?.[index - 1]?.viewCounts?.views) ? accountStats?.[index - 1]?.viewCounts : accountStats?.[index - 1]?.viewCounts || 0;

            // let numberViewsToAdd = 0; //implicit for currentViews == yesterViews. see nb.
            // if (yesterViews > currentViews) numberViewsToAdd = yesterViews - currentViews;
            // if (yesterViews < currentViews) numberViewsToAdd = currentViews - yesterViews;
            profileViewsCount += (currentViews - yesterViews);
            return profileViewsCount;
        }, 0
    );

    return totalProfileViews;

};

export const convertDateToFBTimestamp = (date = null) => {
    if (!date || !moment(date).isValid) return date;
    return firebaseClient.firestore.Timestamp.fromDate(new Date(date));
}

/**
 * Filters out reshared/reposted posts from an array of posts based on several criteria:
 * 
 * 1. Removes duplicates where posts have the same idShare, keeping only the earliest one
 * 2. Removes posts that have no shareUrn metadata and zero views
 * 3. Removes posts explicitly marked as reshared
 *
 * The function uses the following logic:
 * - Compares idShare between posts to find duplicates
 * - Uses created_at timestamp to determine which duplicate to keep
 * - Checks numViews and metadata to identify likely reshares
 * - Handles both Firebase Timestamp and regular Date objects for created_at
 *
 * @param posts - Array of LinkedIn posts objects to filter
 * @returns Filtered array with reshared posts removed
 */
export const removeResharedPosts = async (posts = [] as any) => {
    if (!posts?.length || posts?.lenght < 1) return posts;
    posts = posts.filter((post, index, postArr) => {
        const reShareIndex = postArr.findIndex((p, i) => {
            // Add safety checks for created_at
            const postDate = post?.created_at?.toDate ? post.created_at.toDate() : new Date(post?.created_at);
            const pDate = p?.created_at?.toDate ? p.created_at.toDate() : new Date(p?.created_at);

            return ((post?.idShare === p?.idShare &&
                index !== i &&
                postDate.getTime() > pDate.getTime() &&
                (post.numViews === undefined || post.numViews === 0)) ||
                (Boolean(post?.zFull?.updateMetadata?.shareUrn) === false &&
                    (post.numViews === undefined || post.numViews === 0)) ||
                (post?.zFull?.reshared === true));
        });
        return (reShareIndex === -1) ? true : false;
    });
    return posts;
}
